export const translatePatterns = {
  en: /\btranslate(?:\s+from\s+.+?)?\s+(?:to|into)\s+([A-Za-zÀ-ÿ -]+)\b/i,
  es: /\btraducir(?:\s+de\s+.+?)?\s+a(?:l)?\s+([A-Za-zÀ-ÿ -]+)\b/i,
  de: /\bübersetze(?:\s+von\s+.+?)?\s+(?:nach|ins|in das?)\s+([A-Za-zÀ-ÿ -]+)\b/i,
  it: /\btraduci(?:\s+da\s+.+?)?\s+in\s+([A-Za-zÀ-ÿ -]+)\b/i,
  fr: /\btraduire(?:\s+de\s+.+?)?\s+en\s+([A-Za-zÀ-ÿ -]+)\b/i,
  pt: /\btraduzir(?:\s+de\s+.+?)?\s+para\s+([A-Za-zÀ-ÿ -]+)\b/i,
  zh: /(?:从.+?)?翻译(?:成|到)(.+)/,
};